import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from '../../../../../../shared/shared.module';
import { UsersSearchFormComponent } from './users-search-form.component';

@NgModule({
	imports: [ReactiveFormsModule, SharedModule],
	exports: [UsersSearchFormComponent],
	declarations: [UsersSearchFormComponent],
	providers: []
})
export class UsersSearchFormModule {}
